import isUnsupportedDateRangeTypeForSplitView from './isUnsupportedDateRangeTypeForSplitView';
import notEnoughCalendarsForSplitView from './notEnoughCalendarsForSplitView';

export default function shouldDisableSplitView(): boolean {
    return isUnsupportedDateRangeTypeForSplitView() || notEnoughCalendarsForSplitView();
}
